module.exports = __webpack_public_path__ + "img/John_Dezes.dfb19574.png";